import { validateRut } from '@abstract-cl/rut-ts';
import { RuleObject } from 'antd/lib/form';
import i18n from 'i18n';

const rutFormValidator = (rule: RuleObject, value: string): Promise<void> => {
  if (validateRut(value) || value === '') {
    return Promise.resolve();
  }
  return Promise.reject(new Error(i18n.t('validation.invalidRut')));
};

export default rutFormValidator;
